import { z } from 'zod';
import { STATIC_WIDGET_IDS } from '~/atoms/fundAnalyticsAtom';
import { widgetSchema } from '~/components/ui/dashboard/widgetSchemas';

const citationSchema = z.object({
  explanation: z.string(),
  data: z.string(),
});

const widgetActionSchema = z.enum(['add', 'remove', 'update']);

export type Citation = z.infer<typeof citationSchema>;

export type WidgetAction = z.infer<typeof widgetActionSchema>;

const parsedStreamChatMessageSchema = z.object({
  id: z.string(),
  content: z.string(),
  timestamp: z.string(),
  isUser: z.boolean(),
  isStreaming: z.boolean().optional(),
  originalId: z.string().optional(),
  citations: z.array(citationSchema).optional(),
  widgetAction: widgetActionSchema.nullable().optional(),
  widgets: z.array(widgetSchema).optional(),
  widgetIdToUpdate: z.array(z.string()).optional().nullable(),
});

export type ParsedStreamChatMessage = z.infer<
  typeof parsedStreamChatMessageSchema
>;

export type StreamChatProps = {
  initialMessage?: string;
  onExpandToggle: () => void;
  dashboardId?: string;
};

const AGENT_DYNAMIC_WIDGET_ID_TYPES = [
  'dynamic_table',
  'dynamic_histogram',
  'dynamic_pie_chart',
] as const;

const apiStaticWidgetIdSchema = z.enum(STATIC_WIDGET_IDS);
const agentDynamicWidgetSchema = z.enum(AGENT_DYNAMIC_WIDGET_ID_TYPES);

export type AgentDynamicWidgetIdType =
  (typeof AGENT_DYNAMIC_WIDGET_ID_TYPES)[number];

const agentDynamicWidgetIdSchema = z.object({
  type: agentDynamicWidgetSchema,
  query: z.string(),
  short_description: z.string().optional(),
  is_aggregate: z.boolean().optional(),
});

const agentWidgetIdSchema = z.union([
  z.array(apiStaticWidgetIdSchema),
  z.array(agentDynamicWidgetIdSchema),
]);

export type AgentWidgetIds = z.infer<typeof agentWidgetIdSchema>;

export const agentChatMessageSchema = z.object({
  role: z.string(),
  timestamp: z.string(),
  content: z.string(),
  widget_action: widgetActionSchema.nullable().optional(),
  widget_ids: agentWidgetIdSchema.optional(),
  widget_id_to_update: z.array(z.string()).optional().nullable(),
  citations: z.array(citationSchema).optional(),
  is_aggregate: z.boolean().optional(),
});

export type AgentChatMessage = z.infer<typeof agentChatMessageSchema>;
